import React from 'react'
import FloatingButton from '../Components/FloatingButton.js'
import Footer from '../Components/Footer.js'
import Header from '../Components/Header/Header.js'
import Quotation from '../Components/Quotation.js'

function QuotationPage() {
  return (
    <>
      <Header />
      <Quotation />
      <FloatingButton/>
      <Footer />
    </>
  )
}

export default QuotationPage